import { useAuth } from "@/lib/auth"

export const useSubscriptionCheck = () => {
  const { user } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'useSubscriptionCheck',
  })

  if (!user) {
    return false
  }

  return user.sia === true
}
